import { cn } from "@/libs/utils";
import { flagAssetCode } from "@/libs/countries/flag-asset";
import React from "react";
import Flag from "react-flagpack-react-19";

export default function CountryFlag({
  countryCode,
  className,
  hasBorder = false,
}: {
  countryCode: string | null;
  className?: string;
  hasBorder?: boolean;
}) {
  return (
    <Flag
      code={flagAssetCode(countryCode)}
      className={cn("w-5", className)}
      hasBorder={hasBorder}
    />
  );
}
